
import { useLanguage } from "@/contexts/LanguageContext";
import { useEffect } from "react";
import MenuItem from "./MenuItem";
import AuthButtons from "../AuthButtons";
import { User, ShieldCheck, LogOut, Heart } from "lucide-react";
import LoadingState from "./LoadingState";

interface AccountSectionProps {
  user: any;
  isAdmin: boolean;
  isLoading: boolean;
  showAdminLink: boolean;
  onClose: () => void;
  onAuthModalOpen: (tab: "signin" | "signup") => void;
  handleSignOut: () => void;
  handleAdminClick: () => void;
}

export default function AccountSection({
  user,
  isAdmin,
  isLoading,
  showAdminLink,
  onClose,
  onAuthModalOpen,
  handleSignOut,
  handleAdminClick
}: AccountSectionProps) {
  const { t } = useLanguage();
  
  useEffect(() => {
    if (user) {
      console.log("AccountSection - User authenticated, admin status:", { 
        userId: user.id,
        email: user.email,
        isAdmin, 
        isLoading,
        showAdminLink
      });
    }
  }, [user, isAdmin, isLoading, showAdminLink]);
  
  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">{t("nav.account")}</h2>
      
      {isLoading ? (
        <LoadingState />
      ) : user ? (
        <nav className="space-y-2">
          <MenuItem 
            to="/profile" 
            icon={<User className="h-5 w-5" />} 
            label={t("nav.profile")}
            onClick={onClose}
          />
          <MenuItem 
            to="/favorites" 
            icon={<Heart className="h-5 w-5" />} 
            label={t("nav.favorites")}
            onClick={onClose}
          />
          {showAdminLink && (
            <MenuItem 
              to="/admin" 
              icon={<ShieldCheck className="h-5 w-5" />} 
              label={t("nav.admin")}
              onClick={handleAdminClick}
            />
          )}
          <MenuItem 
            icon={<LogOut className="h-5 w-5" />} 
            label={t("nav.logout")}
            onClick={handleSignOut}
          />
        </nav>
      ) : (
        <div className="space-y-3 px-3">
          <AuthButtons 
            onSignIn={() => {
              onAuthModalOpen("signin");
              onClose();
            }}
            onSignUp={() => {
              onAuthModalOpen("signup");
              onClose();
            }}
            isMobile
          />
        </div>
      )}
    </div>
  );
}
